<div class="row align-items-center justify-content-center">
  <div class="col-lg-4 col-md-4 col-sm-6 col-12">
    <form #smsMfaVerificationForm="ngForm" novalidate (ngSubmit)="formSubmit(smsMfaVerificationForm)">
      <div class="form-group">
        <label>{{mfaFormLabel}}</label><br>
        <small class="text-muted">
          {{mfaFormMessage}} <span *ngIf="smsMfaData">{{smsMfaData.deliveryMedium}} on {{smsMfaData.codeDeliveryDestination}} {{mfaFormMessageTimeLimit}}</span>
        </small>
        <input type="text" class="form-control mt-4" pattern="[0-9]{6}" oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="6" [(ngModel)]="smsMfaVerificationModel.code" name="code"
          #code="ngModel" required>
        <small class="text-danger text-center" *ngIf="code.errors && smsMfaVerificationForm.submitted">
          <p class="mb-0" *ngIf="code.errors.required">Code is required</p>
          <p class="mb-0" *ngIf="!code.errors.required">Invalid verification code</p>
        </small>
      </div>
      <div class="form-group maroon forgot-password mt-3">
        <span (click)="resendMFACode()">Resend code</span>
      </div>
      <div class="text-center mt-4">
        <button type="submit" class="btn btn-primary border">Submit</button>
      </div>
    </form>
  </div>
</div>